<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class="m-b-20" content='1、带参数二维码可用于区分客户的来源，达到客户管理的目的。客户扫了带参数二维码后，会被打上设定的客户标签；同时已关注的客户会收到设定的回复；未关注的客户会先进入公众号关注页，关注后会收到设定的回复（注：带参数二维码有效期为30天）
      2、通过带参数二维码打上的客户标签不会覆盖客户原有的标签，每个客户最多可设置20个标签（包括已有的客户标签）。' :padding='false'></SmallSquare>
      <a-tabs >
        <a-tab-pane key="1" tab="新建带参数二维码">
          <codeList></codeList>
        </a-tab-pane>
        <a-tab-pane key="2" tab="分类管理">
          <typeList></typeList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import codeList from './components/code_list';
import typeList from './components/type_list';
export default {
  components: {codeList,typeList },
  setup(props) {
    const state = reactive({

    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>